// This is being used for the mobility modal in the data overview leave page
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  open(event) {
    event.preventDefault();
    const el = event.currentTarget;
    
    // Show modal overlay
    if (this.hasModalTarget) this.modalTarget.classList.remove("hidden");
    
    // Completely destroy and recreate the turbo frame
    const oldFrame = document.getElementById("mobility_modal");
    if (oldFrame) {
      oldFrame.remove();
    }
    
    // Create new turbo frame
    const newFrame = document.createElement("turbo-frame");
    newFrame.id = "mobility_modal";
    newFrame.innerHTML = `<div data-mobility-modal-target="content" class="space-y-4">Loading...</div>`;
    
    // Find the container and append the new frame
    const container = document.querySelector('[data-mobility-modal-target="content"]');
    if (container) {
      container.appendChild(newFrame);
    }
    
    // Build params and set src
    const params = new URLSearchParams({
      user_id: el.dataset.mobilityModalUserId,
      month: el.dataset.mobilityModalMonth,
      year: el.dataset.mobilityModalYear,
      _ts: Date.now()
    });
    
    // Set src to trigger request
    newFrame.setAttribute("src", `/data_overviews/mobility_modal?${params.toString()}`);
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    // Clear Turbo Frame content and src for next open
    const turboFrame = document.getElementById("mobility_modal")
    if (turboFrame) {
      turboFrame.removeAttribute("src")
      turboFrame.innerHTML = `<div data-mobility-modal-target="content" class="space-y-4"></div>`
    }
  }
} 